'use client';

import PageSection from 'components/PageSection/PageSection';
import { PageSectionProps } from './types';

/**
 * Wraps the PageSection component as a client component
 * @param props - The props to render the PageSection with
 * @returns The rendered component
 */
const ClientPageSection = (props: PageSectionProps) => {
  return <PageSection {...props} />;
};

export default ClientPageSection;
